module.exports = __webpack_public_path__ + "img/icon_address.5854dd23.png";